import Modal from "react-bootstrap/Modal";

const DeleteMerchantModal = ({ show, onHide, deleteMerchant }) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      size="md"
      backdrop={true}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="kitchen-modal"
    >
      <Modal.Header closeButton>
        <span className="fw-bold">حذف مشتری </span>
      </Modal.Header>
      <Modal.Body>
        <div>
          <div>
            <div className="modal-body p-3">
              <p className="fs-5 py-3 mx-1">
                آیا از حذف این مشتری اطمینان دارید؟
              </p>
              <div className="d-flex justify-content-around align-content-center">
                <button
                  type="button"
                  className="btn custome-btn btn-outline-purple w-50 ms-2"
                  onClick={onHide}
                >
                  خیر
                </button>
                <button
                  type="button"
                  className="btn custome-btn btn-danger w-50 me-2"
                  onClick={deleteMerchant}
                >
                  بله
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default DeleteMerchantModal;
